class ValetModal extends window.BaseThirdPartyModal {
  connectedCallback() {
    super.connectedCallback()
    this.fallbackLink = this.querySelector("[data-valet-fallback-link]")
  }

  createWidgetContent(widget, url) {
    const iframe = document.createElement("iframe")
    iframe.src = url
    iframe.title = "Explore Valet Bike Rental Booking"
    iframe.setAttribute("allow", "payment; storage-access")
    widget.appendChild(iframe)
  }

  load(url) {
    this.getWidget(url)
    return Promise.resolve()
  }

  open(url, opener) {
    if (this.fallbackLink) {
      this.fallbackLink.setAttribute("href", url)
    }
    return super.open(url, opener)
  }
}

customElements.define("valet-modal", ValetModal)

document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("valet-modal")
  if (!modal) return

  const urls = new Set(
    Array.from(document.querySelectorAll("[data-valet-url]"), trigger => trigger.getAttribute("data-valet-url"))
  )
  if (urls.size) {
    window.onIdle(() => urls.forEach(url => modal.load(url)))
  }

  document.addEventListener("click", event => {
    const trigger = event.target.closest("[data-valet-url]")
    if (!trigger) return
    event.preventDefault()
    modal.open(trigger.getAttribute("data-valet-url"), trigger)
  })
})
